import React from 'react';

interface MobileNumberFormProps {
  mobileNumber: string;
  isLoading: boolean;
  googleLoading: boolean;
  error: string | null;
  onMobileChange: (value: string) => void;
  onSubmit: (e: React.FormEvent) => void;
  onGoogleLogin: () => void;
}

const MobileNumberForm: React.FC<MobileNumberFormProps> = ({
  mobileNumber,
  isLoading,
  googleLoading,
  error,
  onMobileChange,
  onSubmit,
  onGoogleLogin,
}) => {
  return (
    <form onSubmit={onSubmit}>
      <div className="mb-4">
        <label className="block text-gray-600 text-xs font-semibold uppercase tracking-wide mb-2">Phone Number</label>
        <div className="flex">
          <span className="bg-white/60 text-gray-500 px-3 py-2.5 rounded-l-md border border-r-0 border-gray-200 text-sm">+91</span>
          <input
            type="tel"
            value={mobileNumber}
            onChange={(e) => onMobileChange(e.target.value.replace(/\D/g, '').slice(0, 10))}
            className="flex-1 bg-white/60 text-gray-900 text-sm px-3 py-2.5 rounded-r-md border border-gray-200 focus:outline-none focus:border-orange-400 focus:ring-1 focus:ring-orange-300 focus:bg-white/80 transition-colors"
            placeholder="Enter 10-digit mobile number"
            maxLength={10}
          />
        </div>
      </div>


      {error && (
        <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-md">
          <p className="text-red-600 text-sm">{error}</p>
        </div>
      )}

      <button
        type="submit"
        disabled={isLoading || mobileNumber.length !== 10}
        className="w-full bg-orange-500 hover:bg-orange-600 disabled:bg-gray-300 disabled:cursor-not-allowed text-white py-3 rounded-md font-semibold mb-4 transition-colors"
      >
        {isLoading ? 'Sending OTP...' : 'Get OTP'}
      </button>

      <div className="flex items-center gap-3 my-6">
        <div className="flex-1 h-px bg-gray-200/70" />
        <span className="text-gray-400 text-xs">or continue with</span>
        <div className="flex-1 h-px bg-gray-200/70" />
      </div>

      <button
        type="button"
        onClick={onGoogleLogin}
        disabled={googleLoading}
        className="w-full bg-white/60 hover:bg-white/80 text-gray-700 py-2.5 rounded-md font-medium border border-gray-200 flex items-center justify-center transition-all disabled:opacity-50 disabled:cursor-not-allowed text-sm"
      >
        {googleLoading ? (
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-gray-700 mr-2"></div>
            Signing in...
          </div>
        ) : (
          <>
            <svg className="w-5 h-5 mr-2" viewBox="0 0 24 24">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
            </svg>
            Sign in with Google
          </>
        )}
      </button>
    </form>
  );
};

export default MobileNumberForm;
